module.exports = __webpack_public_path__ + "static/media/YM04_0.34104a6f.jpg";